/**
 * Single source of truth for marketing, pricing toggles, and catalog defaults.
 * Import: `import { CONFIG } from '../config/config';`
 */

export const CONFIG = {
  STORAGE: {
    EARLY_ACCESS: 'basick_early_access',
    GUEST_CART: 'guestCart',
  },

  PRICE: {
    ORIGINAL: 899,
    CURRENT: 659,
    EARLY_BIRD: 499,
    DOLLAR_RATE: 82,
  },

  SALE: {
    ENABLE_BUY3_GET1: true,
    SHOW_BANNER: true,
    BANNER_TEXT: 'Buy 3 Get 1 Free 🔥',
  },

  PRELAUNCH: {
    ENABLED: true,
  },

  UI: {
    SHOW_COMING_SOON: true,
    SHOW_TOP_BANNER: true,
    TOP_BANNER_TEXT: 'Pre-Launch Offer Live 🔥 Limited Time',
  },

  URGENCY: {
    LIMITED_STOCK: 'Limited Stock',
    SELLING_FAST: 'Selling Fast',
  },

  TRUST: {
    COTTON: 'Premium Cotton',
    RETURNS: 'Easy Returns',
  },

  CAPTURE: {
    WHATSAPP_MESSAGE:
      'Get early access on WhatsApp for pre-launch collection at ₹499',
    EMAIL_PLACEHOLDER: 'Your email',
    PHONE_PLACEHOLDER: 'WhatsApp number',
    STEP1_CTA: 'Continue',
    STEP2_CTA: 'Unlock early access',
  },

  CTA: {
    BUY_NOW: 'Buy Now',
  },

  CATEGORIES: [
    { id: 't-shirts', name: 'T-Shirts', active: true },
    { id: 'hoodies', name: 'Hoodies', active: false },
    { id: 'pants', name: 'Pants', active: false },
    { id: 'accessories', name: 'Accessories', active: false },
  ],

  PRODUCT: {
    NAME: 'Classic Black Tee',
    SKU: 'BAS-001',
    DESCRIPTION:
      'Premium cotton tee with a clean, minimal silhouette. Pre-shrunk fabric and reinforced seams for everyday wear.',
    DETAILS_EXTRA:
      'Designed for a modern fit. Machine wash cold. Each piece is finished for a soft hand-feel and lasting shape.',
    FEATURES: [
      'Premium Cotton',
      'Reinforced seams',
      'Pre-shrunk',
      'Minimal branding',
    ],
    IMAGES: [
      '/images/tee-1.svg',
      '/images/tee-2.svg',
      '/images/tee-3.svg',
      '/images/tee-4.svg',
    ],
    SIZES: ['M', 'L', 'XL'],
    COLORS: [
      { name: 'Black', code: '#000000' },
      { name: 'White', code: '#FFFFFF' },
    ],
    REVIEWS: [
      { stars: 5, text: 'Amazing quality, perfect fit!', author: 'Aayush' },
      { stars: 4, text: 'Worth the price, will buy again.', author: 'Riya' },
      { stars: 5, text: 'Minimal and classy.', author: 'Karan' },
    ],
  },

  FOOTER: {
    COPYRIGHT_SUFFIX: 'Prices shown in INR (USD estimate).',
  },
};